// Core packages
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Third party packages

// Custom packages - Misc
import { RoleGuard } from 'src/app/shared/guards/role.guard';

// Custom packages - Component
import { CaretakersListComponent } from 'src/app/modules/caretakers/pages/caretakers-list/caretakers-list.page';

const routes: Routes = [
  {
    path: 'list',
    component: CaretakersListComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canReadPropertiesList']
    },
  },
  {
    path: '**',
    redirectTo: 'it/errors/404'
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class CaretakersRoutingModule { }
